require('./brokerStocksAdvancedBuyStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');
const classNames = require('classnames');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_STOCKS_ADVANCED_BUY_FIELDS_MAXLENGHT_LIMIT,
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_RESTRICTED_ORDER_TERM,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK,
    MAX_FRACTION_LENGTH_IN_STORE_LIMITED
} = require('constants/index');
const { STOCKS_ADVANCED_BUY_CODE } = require('constants/operationCodesAccounts');
const nonNumericRegex = /[^\d]/g;
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @ commons
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ components
const { AmountInput } = require('commonsComponents/amountInput');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const BrokerStocksAdvancedBuyActions = require('actions/brokerStocksAdvancedBuy');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const BlockedAccounts = require('actions/blockedAccounts');

// @ utils
const { formatAmount } = require('utilities/currencyHelper');

class BrokerStocksAdvancedBuyStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleTitleQuantityChanged = this.handleTitleQuantityChanged.bind(this);
        this.handleOnChangeRadioButtons = this.handleOnChangeRadioButtons.bind(this);
    }

    componentDidMount() {
        const { immBrokerStocksAdvancedBuy, handleValidityDateChanged, getBlockedAccounts, immAccounts } = this.props;
        const step1 = immBrokerStocksAdvancedBuy.get('steps').get(FIRST_STEP);
        let initialValidityDate;

        //If it is a restricted order then we will have validity date for the purchase
        if (step1.get('orderTerms') === BROKER_RESTRICTED_ORDER_TERM) {
            initialValidityDate = moment().add(90, 'days');
        }

        handleValidityDateChanged(initialValidityDate);
        this.props.fetchMyInvestments();

        getBlockedAccounts(immAccounts.get('byId').toList(), STOCKS_ADVANCED_BUY_CODE);
    }

    handleTitleQuantityChanged(event) {
        this.props.titleQuantityChanged(event.target.value.replace(nonNumericRegex, '').trim());
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContract } = this.props;

        const processedStocksContract = immStocksContract.map((entry, index) => {
            const associatedAccountBalance = {
                amount: entry.getIn(['associatedAccountBalance', 'amount']),
                currency: entry.getIn(['associatedAccountBalance', 'currency'])
            };

            return entry.merge({
                value: index,
                walletBalance: associatedAccountBalance
            });
        });

        return processedStocksContract.toJS();
    }

    conditionalInput(forTheBestOptionPresent, labelLimitedInput) {
        const { immBrokerStocksAdvancedBuy, limitedValueChanged } = this.props;
        const limitedValue = immBrokerStocksAdvancedBuy
        .get('steps')
        .get(SECOND_STEP)
        .get('orderTypeValue');
        const orderTypeValueValid =
            immBrokerStocksAdvancedBuy.get('steps').get(SECOND_STEP).get('orderTypeValueValid') !==
            undefined
                ? immBrokerStocksAdvancedBuy
                      .get('steps')
                      .get(SECOND_STEP)
                      .get('orderTypeValueValid')
                : true;

        const wrapperClasses = classNames('stocks-advanced-buy-step2__text-input-wrapper', {
            'stocks-advanced-buy-step2__text-input-wrapper--small-margin': !forTheBestOptionPresent
        });
        const inputFootValidator = !orderTypeValueValid ? undefined : labelLimitedInput;
        return (
            <div className={wrapperClasses}>
                <AmountInput
                    id="limitedValue"
                    min={0}
                    callback={limitedValueChanged}
                    amount={limitedValue}
                    error={!orderTypeValueValid}
                    errorMsg={formatText('broker-stocksBuyStep1NoLimitedAmmount')}
                    maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE_LIMITED}
                    language={language}
                    hideFocusZero
                />
                {inputFootValidator}
            </div>
        );
    }

    handleOnChangeRadioButtons(value){
        const { immBrokerStocksAdvancedBuy, onOrderTypeChanged} = this.props;
        const step2 = immBrokerStocksAdvancedBuy.get('steps').get(SECOND_STEP);
        const loading = step2.get('loading');
        if(!loading){
            onOrderTypeChanged(value);
        }
    }

    buildOrderTypeBlock() {
        const { immBrokerStocksAdvancedBuy, iso, catalogData } = this.props;
        const step2 = immBrokerStocksAdvancedBuy.get('steps').get(SECOND_STEP);
        const orderType = step2.get('orderTypeOption');
        const toMarketRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedBuyStep2ToMarketLabel')}
                value={BROKER_ORDER_TYPE_TO_MARKET}
                className="stocks-advanced-buy-step2__radio-button"
            />
        );
        const forTheBestRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedBuyStep2ForTheBestLabel')}
                value={BROKER_ORDER_TYPE_FOR_THE_BEST}
                className="stocks-advanced-buy-step2__radio-button"
            />
        );
        const limitedRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedBuyStep2LimitedLabel', [
                    immBrokerStocksAdvancedBuy.get('productCurrency')
                ])}
                value={BROKER_ORDER_TYPE_LIMITED}
                className="stocks-advanced-buy-step2__radio-button"
            />
        );
        const forTheBestOptionPresent =
            iso === SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK ||
            iso === SPANISH_CONTINUES_MARKET_ISO_CODE;

        let limitedInput;
        let radioButtonGroup;

        if (orderType === BROKER_ORDER_TYPE_LIMITED) {
            const limitedLabel = catalogData.get('operatedByLot') ?
            (
                <div className="stocks-advanced-buy-step2__input-foot">
                    {formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_titleLimitPrice')}
                </div>
            ) : null;
            limitedInput = this.conditionalInput(forTheBestOptionPresent, limitedLabel);
        }

        //We can't just render a radio button group with a conditional "for the best" radio button because
        //when it doesn't apply (not spanish market) the variable is null and the radio button group component explodes.
        if (forTheBestOptionPresent) {
            radioButtonGroup = (
                <RadioButtonGroup
                    selectedValue={orderType}
                    onChange={this.handleOnChangeRadioButtons}
                    name="stocksAdvancedBuyOrderType"
                    idPrefix="stocksAdvancedBuyOrderType"
                >
                    {toMarketRadioButton}
                    {forTheBestRadioButton}
                    {limitedRadioButton}
                </RadioButtonGroup>
            );
        } else {
            radioButtonGroup = (
                <RadioButtonGroup
                    selectedValue={orderType}
                    onChange={this.handleOnChangeRadioButtons}
                    name="stocksAdvancedBuyOrderType"
                    idPrefix="stocksAdvancedBuyOrderType"
                >
                    {toMarketRadioButton}
                    {limitedRadioButton}
                </RadioButtonGroup>
            );
        }

        return (
            <div className="stocks-advanced-buy-step2__group-div">
                <h2 className="stocks-advanced-buy-step2__subtitle">
                    <FormattedText value="broker-stocksAdvancedBuyStep2OrderTypeTitle" />
                    <OKTooltip
                        content="broker-stocksAdvancedBuyStep2OrderTypeTooltip"
                        offset={[0, -15]}
                    />
                </h2>
                {radioButtonGroup}
                {limitedInput}
            </div>
        );
    }

    buildValidityDateBlock(validityDate, limitDate) {
        const { handleValidityDateChanged } = this.props;

        return (
            <div className="stocks-advanced-buy-step2__group-div">
                <h4 className="stocks-advanced-buy-step2__subtitle">
                    <FormattedText value="broker-stocksAdvancedBuyStep2ValidityDate" />
                    <OKTooltip
                        content="broker-stocksAdvancedBuyStep2ValidityDateTooltip"
                        offset={[0, -15]}
                    />
                </h4>
                <DatePickerCustom
                    callback={handleValidityDateChanged}
                    selectedDate={validityDate}
                    maxDate={limitDate}
                    placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                    locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                    dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                />
            </div>
        );
    }

    render() {
        const { immBrokerStocksAdvancedBuy, stockContractChanged, catalogData, immAccounts } = this.props;
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const orderTypeBlock = this.buildOrderTypeBlock();
        const step2 = immBrokerStocksAdvancedBuy.get('steps').get(SECOND_STEP);
        const stocksContractSelectedValue = step2.get('selectedOptionValue');
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const titleQuantity = step2.get('titleQuantity');
        let titleQuantityValid = true;
        let tooltipLot;

        let errorMessage;
        let operatedByLotLabel;
        const orderTypeValid = step2.get('orderTypeValid') !== undefined ?
            step2.get('orderTypeValid') :
            true;
        const validityDate = step2.get('validityDate');
        const limitDate = step2.get('limitDate');

        if(catalogData.get('operatedByLot')){
            const lot = formatAmount(catalogData.get('lot'), undefined, 0);
            let titleQuantityNotMultiplo = step2.getIn(['errorFlags','notMultiploLote']);
            let titleQuantityMinorThanLote = step2.getIn(['errorFlags','minorThanLote']);

            const valueLabel = formatAmount(Number((titleQuantity * catalogData.get('lotValue') / catalogData.get('lot')).toFixed(3)), undefined, 3);

            tooltipLot = (
                <OKTooltip
                    content="brokerOperacionPorLotes-brokerOperacionPorLotes_operatedByLots"
                    offset={[0, -5]}
                />
            );
            if (titleQuantityNotMultiplo && !titleQuantityMinorThanLote) {
                titleQuantityValid = false;
                errorMessage = formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_notMultiplo');
            }
            if (titleQuantityMinorThanLote) {
                titleQuantityValid = false;
                errorMessage = <FormattedText value="brokerOperacionPorLotes-brokerOperacionPorLotes_notEnoughTitlesForLotError" injectedStrings={[lot]}/>;
            }
            if (!titleQuantityNotMultiplo && !titleQuantityMinorThanLote) {
                operatedByLotLabel = <FormattedText className="stocks-advanced-buy-step2__input-foot" value="brokerOperacionPorLotes-brokerOperacionPorLotes_buyByTitle" injectedStrings={[lot, valueLabel]}/>;
            }
        } else {
            titleQuantityValid = step2.get('titleQuantityValid', true);
            errorMessage = formatText('broker-stocksAdvancedSellTitleQuantityMin');
        }

        let validityDateBlock;

        if (validityDate) {
            validityDateBlock = this.buildValidityDateBlock(validityDate, limitDate);
        }

        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        let dropdownSection;

        if (this.props.immMyInvestments.get('isFetching')) {
            dropdownSection = <LoadingSection />;
        } else {
            dropdownSection = (
                <StocksContractDropdown
                    immAccounts={immAccounts}
                    onStockContractChange={stockContractChanged}
                    options={stocksContractDropdownOptions}
                    selectedValue={stocksContractSelectedValue}
                    placeholder={stocksContractPlaceholder}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER}
                    errorState={!orderTypeValid}
                    errorMessage={formatText('broker-stocksAdvancedSellAccountError')}
                    loading={isBlockedAccountsLoading}
                />
            );
        }

        return (
            <div className="stocks-advanced-buy-step2">
                <header className="stocks-advanced-buy-step2__header">
                    <h2 className="stocks-advanced-buy-step2__header-title">
                        <FormattedText value="broker-stocksAdvancedBuyStep2HeaderTitle" />
                    </h2>
                </header>
                <FormattedText
                    value="broker-stocksAdvancedBuyStep2InstructionsText"
                    className="stocks-advanced-buy-step2__info-text"
                />
                <div className="stocks-advanced-buy-step2__dropdown">
                    {dropdownSection}
                </div>
                <div className="stocks-advanced-buy-step2__group-div">
                    <div className="stocks-advanced-buy-step2__tooltip">
                        <h2 className="stocks-advanced-buy-step2__subtitle">
                            <FormattedText value="broker-stocksAdvancedBuyStep2TitleQuantityText" />
                            {tooltipLot}
                        </h2>
                    </div>
                    <div className="stocks-advanced-buy-step2__text-input-wrapper stocks-advanced-buy-step2__text-input-wrapper--left">
                        <InputSafe
                            type="text"
                            value={titleQuantity}
                            autoComplete="off"
                            onChange={this.handleTitleQuantityChanged}
                            maxLength={BROKER_STOCKS_ADVANCED_BUY_FIELDS_MAXLENGHT_LIMIT}
                            errorState={!titleQuantityValid}
                            errorMessage={errorMessage}
                        />
                        {operatedByLotLabel}
                    </div>
                </div>
                {orderTypeBlock}
                {validityDateBlock}
            </div>
        );
    }
}

BrokerStocksAdvancedBuyStep2.propTypes = {
    immBrokerWallets: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerStocksAdvancedBuy: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    titleQuantityChanged: PropTypes.func.isRequired,
    onOrderTypeChanged: PropTypes.func.isRequired,
    limitedValueChanged: PropTypes.func.isRequired,
    handleValidityDateChanged: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    isin: PropTypes.string.isRequired,
    iso: PropTypes.string.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    catalogData: PropTypes.object.isRequired
};

module.exports.constructor = BrokerStocksAdvancedBuyStep2;

module.exports.BrokerStocksAdvancedBuyStep2 = connect(
    state => ({
        immBrokerWallets: state.brokerWallets,
        immAccounts: state.accounts,
        immMyInvestments: state.brokerMyInvestments
    }),
    {
        stockContractChanged: BrokerStocksAdvancedBuyActions.stockContractChanged,
        titleQuantityChanged: BrokerStocksAdvancedBuyActions.titleQuantityChanged,
        getBlockedAccounts: BlockedAccounts.getBlockedAccounts,
        onOrderTypeChanged: BrokerStocksAdvancedBuyActions.orderTypeChanged,
        limitedValueChanged: BrokerStocksAdvancedBuyActions.limitedValueChanged,
        handleValidityDateChanged: BrokerStocksAdvancedBuyActions.validityDateChanged,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments
    }
)(BrokerStocksAdvancedBuyStep2);
